import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Consultation from './pages/Consultation';
import StartPractice from './pages/StartPractice';
import CancellationAndRefund from './pages/CancellationAndRefund';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
import { analytics } from './firebase';
import './App.css';

function App() {
  useEffect(() => {
    // Initialize Firebase Analytics
    console.log('Firebase Analytics initialized:', analytics);
  }, []);

  return (
    <div className="App">
      <Navigation />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/consultation" element={<Consultation />} />
          <Route path="/start-practice" element={<StartPractice />} />
          <Route path="/cancellation-refund" element={<CancellationAndRefund />} />
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;